import { connect } from "@formily/react";
import { Image as AntImage } from "antd";

export const Image = connect((props) => {
  const enhancedProps = {
    ...props,
    preview: props.preview !== undefined ? props.preview : false,
  };

  return <AntImage {...enhancedProps}>{enhancedProps.children}</AntImage>;
});
